<script setup lang="ts">
import IconEventyourAdminTitle from "../../../assets/image/eventYour/icons/icon-eventYour-admin-title.svg";
import Title from "../../../components/website/LayoutTitleSection.vue";
import { useTranslate } from "addeus-common-library/stores/translate";
import ImageHeader from "../../../components/website/ImageHeader.vue";
import BlockInfo from "../../../components/website/BlockInfo.vue";
import Footer from "../../../components/website/Footer.vue";
import ProductTechnologyNavigation from "../../../components/website/ProductTechnologyNavigation.vue";
import VFlex from "addeus-common-library/components/base/flex/VFlex.vue";
// Breakpoints
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
const breakpoints = useBreakpoints(breakpointsTailwind);
const smallerThanSm = breakpoints.smallerOrEqual("sm");
const smallerThanMd = breakpoints.smallerOrEqual("md");
const smallerThanXl = breakpoints.smallerOrEqual("xl");
const isBetweenLg = breakpoints.between("lg", "xl");
const isBetweenMd = breakpoints.between("md", "xl");
const isBetweenMdLg = breakpoints.between("md", "lg");

import VideoHeader from "../../../assets/video/fabrication.mp4";
//
// import images
import ImageIdentity from "../../../assets/image/productTechnology/kart/identity.jpg";
import IconIdentity1 from "../../../assets/image/productTechnology/kart/icons/technology-identity-electric.svg";
import IconIdentity2 from "../../../assets/image/productTechnology/kart/icons/technology-identity-diy.svg";
import IconIdentity3 from "../../../assets/image/productTechnology/kart/icons/technology-identity-fr.svg";
import IconCaracteristicPower from "../../../assets/image/productTechnology/kart/icons/technology-carateristic-power.svg";
import IconCaracteristicSize from "../../../assets/image/productTechnology/kart/icons/technology-carateristic-size.svg";
import IconCaracteristicDimension from "../../../assets/image/productTechnology/kart/icons/technology-carateristic-dimension.svg";
import IconCaracteristicTypology1 from "../../../assets/image/productTechnology/kart/icons/technology-carateristic-typology-1.svg";
import IconCaracteristicTypology2 from "../../../assets/image/productTechnology/kart/icons/technology-carateristic-typology-2.svg";
import IconCaracteristicTypology3 from "../../../assets/image/productTechnology/kart/icons/technology-carateristic-typology-3.svg";
import IconCaracteristicTypology4 from "../../../assets/image/productTechnology/kart/icons/technology-carateristic-typology-4.svg";
import IconCaracteristicTypology5 from "../../../assets/image/productTechnology/kart/icons/technology-carateristic-typology-5.svg";
import IconCaracteristicTypology6 from "../../../assets/image/productTechnology/kart/icons/technology-carateristic-typology-6.svg";
import IconCaracteristicPilot1 from "../../../assets/image/productTechnology/kart/icons/technology-carateristic-pilot-1.svg";
import IconCaracteristicPilot2 from "../../../assets/image/productTechnology/kart/icons/technology-carateristic-pilot-2.svg";
import IconCaracteristicPilot3 from "../../../assets/image/productTechnology/kart/icons/technology-carateristic-pilot-3.svg";
import IconCaracteristicPilot4 from "../../../assets/image/productTechnology/kart/icons/technology-carateristic-pilot-4.svg";
import IconCaracteristicPilotYear from "../../../assets/image/productTechnology/kart/icons/technology-carateristic-pilot-year.svg";
import IconPerformanceBattery from "../../../assets/image/productTechnology/kart/icons/technology-performance-battery.svg";
import IconPerformanceIndicator1 from "../../../assets/image/productTechnology/kart/icons/technology-performance-indicator-1.svg";
import IconPerformanceIndicator2 from "../../../assets/image/productTechnology/kart/icons/technology-performance-indicator-2.svg";
import IconDurability1 from "../../../assets/image/productTechnology/kart/icons/technology-durability-1.svg";
import IconDurability2 from "../../../assets/image/productTechnology/kart/icons/technology-durability-2.svg";
import IconDurability3 from "../../../assets/image/productTechnology/kart/icons/technology-durability-3.svg";
import IconDurability4 from "../../../assets/image/productTechnology/kart/icons/technology-durability-4.svg";
import IconDurability5 from "../../../assets/image/productTechnology/kart/icons/technology-durability-5.svg";
import IconConception1 from "../../../assets/image/productTechnology/kart/icons/technology-conception-1.svg";
import IconConception2 from "../../../assets/image/productTechnology/kart/icons/technology-conception-2.svg";
import IconConception3 from "../../../assets/image/productTechnology/kart/icons/technology-conception-3.svg";
import IconConception4 from "../../../assets/image/productTechnology/kart/icons/technology-conception-4.svg";
import IconConception5 from "../../../assets/image/productTechnology/kart/icons/technology-conception-5.svg";
import IconConception6 from "../../../assets/image/productTechnology/kart/icons/technology-conception-6.svg";

import ImageSecurity1 from "../../../assets/image/productTechnology/kart/security-1.png";
import ImageSecurity2 from "../../../assets/image/productTechnology/kart/security-2.png";
import ImageSecurity3 from "../../../assets/image/productTechnology/kart/security-3.png";
import ImageSecurity4 from "../../../assets/image/productTechnology/kart/security-4.png";
import ImageSecurity5 from "../../../assets/image/productTechnology/kart/security-5.png";

import ImagePerformance from "../../../assets/image/productTechnology/kart/performance.jpg";

// Sustainability

import { useSeoMeta } from "../../../composables/useSeoMeta";

const { setTranslateNamespace } = useTranslate();
setTranslateNamespace(".productTechnology.karting");

useSeoMeta({
    title: "Kart électrique professionnel | Fabricant français",
    description:
        "Kart électrique professionnel Speed2Max SLC2 : fabriqué en France, 120 km/h, batteries longue durée. Vente de karts pour exploitants, parcs de loisirs et pistes indoor. Devis flotte et SAV.",
    path: "/product-technology/karting",
    breadcrumbs: [
        { name: "Accueil", path: "/" },
        { name: "Produits & Technologies", path: "/product-technology/karting" },
        { name: "Karts électriques", path: "/product-technology/karting" },
    ],
    schemaOrg: {
        "@context": "https://schema.org",
        "@type": "Product",
        name: "Speed2Max SLC2 - Kart électrique professionnel",
        description:
            "Kart électrique professionnel 100% fabriqué en France. Autonomie longue durée, vitesse jusqu'à 120 km/h, batteries lithium, maintenance réduite. Idéal pour exploitants et parcs de loisirs.",
        url: "https://speed2max.com/product-technology/karting",
        brand: {
            "@type": "Brand",
            name: "Speed2Max",
        },
        manufacturer: {
            "@type": "Organization",
            name: "Speed2Max",
            url: "https://speed2max.com",
        },
        category: "Kart électrique professionnel",
    },
});

function goTo($event) {
    document.querySelector(`#${$event}`).scrollIntoView({
        behavior: "smooth",
        block: "start",
    });
}
</script>

<template>
    <VFlex flex-direction="column" class="has-background-dark">
        <ProductTechnologyNavigation current="karting"></ProductTechnologyNavigation>
        <ImageHeader>
            <template #image>
                <div :class="{ 'video-landing': !smallerThanXl }" style="display: flex">
                    <video
                        playsinline
                        loop
                        muted
                        autoplay
                        crossorigin="anonymous"
                        :class="{ 'mb-4': smallerThanXl }">
                        <source :src="VideoHeader" />
                    </video>
                </div>
            </template>
            <template #title>
                <div><Translate path=".title"></Translate></div>
                <div class="has-text-primary"><Translate path=".title2"></Translate></div>
            </template>
            <template #icon>
                <img :src="IconEventyourAdminTitle" alt="administration icon" />
            </template>
        </ImageHeader>
        <Timeline @go-to="goTo"></Timeline>
        <!-- Identity -->
        <TranslateNamespace path=".identity">
            <VFlex
                id="identity"
                flex-direction="column"
                class="has-background-white py-6">
                <Title>
                    <template #titleP1> <Translate path=".titleP1"></Translate></template>
                    <template #titleP2> <Translate path=".titleP2"></Translate></template>
                </Title>
                <VFlex
                    :flex-direction="smallerThanMd ? 'column' : 'row'"
                    row-gap="1rem"
                    column-gap="1rem"
                    class="px-6 py-5">
                    <div class="img-identity-karting"></div>
                    <BlockInfo>
                        <template #title>
                            <Translate path=".title"></Translate>
                        </template>

                        <template #content>
                            <div class="is-size-6">
                                <div><Translate path=".content"></Translate></div>
                                <div><Translate path=".content2"></Translate></div>
                                <div><Translate path=".content3"></Translate></div>
                                <div class="mt-2">
                                    <Translate path=".subContent"></Translate>
                                </div>
                                <div>
                                    <Translate path=".subContent2"></Translate>
                                </div>
                                <div><Translate path=".subContent3"></Translate></div>
                            </div>
                        </template>
                    </BlockInfo>
                </VFlex>
                <VFlex
                    :flex-direction="
                        smallerThanMd ? 'column' : isBetweenLg ? 'column' : 'row'
                    "
                    row-gap="3rem"
                    column-gap="3rem"
                    justify-content="space-evenly"
                    class="px-6 pt-5">
                    <div class="has-text-dark has-text-centered bloc-icon-identity">
                        <img
                            :src="IconIdentity1"
                            alt="icone piste"
                            class="icon-identity mb-3" />
                        <div class="is-size-4 is-weight-700">
                            <span class="has-text-primary pr-2"
                                ><Translate path=".percent"></Translate
                            ></span>
                            <Translate path=".electric"></Translate>
                        </div>
                    </div>
                    <div class="has-text-dark has-text-centered bloc-icon-identity">
                        <img
                            :src="IconIdentity2"
                            alt="icone piste"
                            class="icon-identity mb-3" />
                        <div class="is-size-4 is-weight-700">
                            <span class="has-text-primary pr-2"
                                ><Translate path=".percent"></Translate
                            ></span>
                            <Translate path=".diy"></Translate>
                        </div>
                    </div>
                    <div class="has-text-dark has-text-centered bloc-icon-identity">
                        <img
                            :src="IconIdentity3"
                            alt="icone piste"
                            class="icon-identity mb-3" />
                        <div class="is-size-4 is-weight-700">
                            <span class="has-text-primary pr-2"
                                ><Translate path=".percent"></Translate
                            ></span>
                            <Translate path=".madeIn"></Translate>
                        </div>
                    </div>
                </VFlex>
            </VFlex>
        </TranslateNamespace>
        <!-- END - Identity -->
        <!-- Caracteristic -->
        <TranslateNamespace path=".feature">
            <VFlex id="feature" flex-direction="column" class="has-background-white pb-6">
                <Title>
                    <template #titleP1> <Translate path=".titleP1"></Translate></template>
                    <template #titleP2> <Translate path=".titleP2"></Translate></template>
                </Title>
                <TranslateNamespace path=".caracteristic">
                    <VFlex
                        :flex-direction="smallerThanXl ? 'column' : 'row'"
                        row-gap="2rem"
                        column-gap="2rem"
                        align-items="flex-start"
                        class="px-6">
                        <VFlex
                            :flex-direction="isBetweenMd ? 'row' : 'column'"
                            row-gap="1rem"
                            column-gap="1rem"
                            class="mb-2">
                            <!-- Icon POWER -->
                            <VFlex
                                flex-direction="row"
                                row-gap="1rem"
                                column-gap="1rem"
                                align-items="center"
                                class="lighter-bloc p-5 has-text-dark">
                                <img
                                    :src="IconCaracteristicPower"
                                    alt="icone puissance"
                                    class="w-35" />
                                <div class="is-size-5 is-weight-700">
                                    <span class="pr-2"
                                        ><Translate path=".iconPowerTitle"></Translate
                                    ></span>
                                    <span class="has-text-primary"
                                        ><Translate path=".iconPowerContent"></Translate
                                    ></span>
                                </div>
                            </VFlex>
                            <!-- END - Icon POWER -->
                            <!-- Icon SIZE -->
                            <VFlex
                                flex-direction="row"
                                row-gap="1rem"
                                column-gap="1rem"
                                align-items="center"
                                class="lighter-bloc p-5 has-text-dark">
                                <img
                                    :src="IconCaracteristicSize"
                                    alt="icone poids"
                                    class="w-35" />
                                <div class="is-size-5 is-weight-700">
                                    <span class="pr-2"
                                        ><Translate path=".iconSizeTitle"></Translate
                                    ></span>
                                    <span class="has-text-primary"
                                        ><Translate path=".iconSizeContent"></Translate
                                    ></span>
                                </div>
                            </VFlex>
                            <!-- END - Icon SIZE -->
                            <!-- Icon DIMENSION -->
                            <VFlex
                                flex-direction="row"
                                row-gap="1rem"
                                column-gap="1rem"
                                align-items="center"
                                class="lighter-bloc p-5 has-text-dark">
                                <img
                                    :src="IconCaracteristicDimension"
                                    alt="icone dimension"
                                    class="w-35" />
                                <div class="is-size-5 is-weight-700">
                                    <span class="pr-2"
                                        ><Translate path=".iconDimensionTitle"></Translate
                                    ></span>
                                    <span class="has-text-primary"
                                        ><Translate
                                            path=".iconDimensionContent"></Translate
                                    ></span>
                                </div>
                            </VFlex>
                            <!-- END - Icon DIMENSION -->
                        </VFlex>
                        <VFlex
                            flex-direction="column"
                            column-gap="1rem"
                            row-gap="1rem"
                            :align-items="smallerThanMd ? 'center' : 'flex-end'"
                            class="w-100">
                            <VFlex
                                flex-direction="row"
                                column-gap="1rem"
                                row-gap="1rem"
                                justify-content="center"
                                flex-wrap="wrap">
                                <div
                                    class="typology has-text-centered has-text-primary is-size-5 is-weight-500">
                                    <img
                                        :src="IconCaracteristicTypology1"
                                        alt="icone bitume"
                                        class="w-90" />
                                    <div><Translate path=".typology1"></Translate></div>
                                </div>
                                <div
                                    class="typology has-text-centered has-text-primary is-size-5 is-weight-500">
                                    <img
                                        :src="IconCaracteristicTypology2"
                                        alt="icone béton lisse"
                                        class="w-90" />
                                    <div><Translate path=".typology2"></Translate></div>
                                </div>
                                <div
                                    class="typology has-text-centered has-text-primary is-size-5 is-weight-500">
                                    <img
                                        :src="IconCaracteristicTypology3"
                                        alt="icone glace"
                                        class="w-90" />
                                    <div><Translate path=".typology3"></Translate></div>
                                </div>
                                <div
                                    class="typology has-text-centered has-text-primary is-size-5 is-weight-500">
                                    <img
                                        :src="IconCaracteristicTypology4"
                                        alt="icone sol dur"
                                        class="w-90" />
                                    <div><Translate path=".typology4"></Translate></div>
                                </div>
                                <div
                                    class="typology has-text-centered has-text-grey is-size-5 is-weight-300">
                                    <img
                                        :src="IconCaracteristicTypology5"
                                        alt="icone herbe"
                                        class="w-90" />
                                    <div><Translate path=".typology5"></Translate></div>
                                </div>
                                <div
                                    class="typology has-text-centered has-text-grey is-size-5 is-weight-300">
                                    <img
                                        :src="IconCaracteristicTypology6"
                                        alt="icone terre"
                                        class="w-90" />
                                    <div><Translate path=".typology6"></Translate></div>
                                </div>
                            </VFlex>
                            <VFlex
                                flex-direction="row"
                                column-gap="1rem"
                                row-gap="1rem"
                                justify-content="center"
                                flex-wrap="wrap"
                                class="mt-3">
                                <div
                                    class="pilot-type lighter-bloc has-text-centered is-uppercase has-text-dark is-size-5 is-weight-500 p-5">
                                    <img
                                        :src="IconCaracteristicPilot1"
                                        alt="icone pilote débutant"
                                        class="h-90" />
                                    <div class="mt-2">
                                        <Translate path=".pilotType1"></Translate>
                                    </div>
                                </div>
                                <div
                                    class="pilot-type lighter-bloc has-text-centered is-uppercase has-text-dark is-size-5 is-weight-500 p-5">
                                    <img
                                        :src="IconCaracteristicPilot2"
                                        alt="icone pilote intermédiaire"
                                        class="h-90" />
                                    <div class="mt-2">
                                        <Translate path=".pilotType2"></Translate>
                                    </div>
                                </div>
                                <div
                                    class="pilot-type lighter-bloc has-text-centered is-uppercase has-text-dark is-size-5 is-weight-500 p-5">
                                    <img
                                        :src="IconCaracteristicPilot3"
                                        alt="icone confirmé"
                                        class="h-90" />
                                    <div class="mt-2">
                                        <Translate path=".pilotType3"></Translate>
                                    </div>
                                </div>
                                <div
                                    class="pilot-type lighter-bloc has-text-centered is-uppercase has-text-dark is-size-5 is-weight-500 p-5">
                                    <img
                                        :src="IconCaracteristicPilot4"
                                        alt="icone expert"
                                        class="h-90" />
                                    <div class="mt-2">
                                        <Translate path=".pilotType4"></Translate>
                                    </div>
                                </div>
                                <div
                                    class="pilot-type has-background-primary has-text-centered is-uppercase has-text-white is-size-5 is-weight-600 p-5">
                                    <img
                                        :src="IconCaracteristicPilotYear"
                                        alt="icone age minimum"
                                        class="h-90" />
                                    <div class="mt-2">
                                        <Translate path=".pilotTypeYear"></Translate>
                                    </div>
                                </div>
                            </VFlex>
                        </VFlex>
                    </VFlex>
                    <VFlex
                        :flex-direction="smallerThanXl ? 'column' : 'row'"
                        row-gap="2rem"
                        column-gap="2rem"
                        align-items="flex-start"
                        justify-content="space-between"
                        class="px-6 mt-5">
                        <TranslateNamespace path=".motorisation">
                            <VFlex
                                flex-direction="column"
                                row-gap="1rem"
                                column-gap="1rem">
                                <div
                                    class="is-size-3 is-weight-700 subtitle-bebas has-text-dark is-uppercase">
                                    <Translate path=".motorTitle"></Translate>
                                </div>
                                <VFlex
                                    :flex-direction="isBetweenMd ? 'row' : 'column'"
                                    row-gap="1rem"
                                    column-gap="1rem"
                                    class="mb-2 has-text-dark is-uppercase">
                                    <!-- Content Motorisation -->

                                    <div
                                        class="is-size-5 is-weight-700 lighter-bloc p-5 w-motor">
                                        <Translate path=".motorContent1"></Translate>
                                    </div>
                                    <div
                                        class="is-size-5 is-weight-700 lighter-bloc p-5 w-motor">
                                        <Translate path=".motorContent2"></Translate>
                                    </div>
                                    <div
                                        class="is-size-5 is-weight-700 lighter-bloc p-5 w-motor">
                                        <Translate path=".motorContent3"></Translate>
                                    </div>
                                    <!-- END - Content Motorisation -->
                                </VFlex>
                            </VFlex>
                        </TranslateNamespace>
                        <TranslateNamespace path=".battery">
                            <VFlex
                                flex-direction="column"
                                row-gap="1rem"
                                column-gap="1rem"
                                class="w-100">
                                <div
                                    class="is-uppercase is-size-3 is-weight-700 subtitle-bebas has-text-dark">
                                    <Translate path=".batteryTitle"></Translate>
                                </div>
                                <VFlex
                                    :flex-direction="smallerThanXl ? 'column' : 'row'"
                                    column-gap="1rem"
                                    row-gap="1rem"
                                    :justify-content="
                                        smallerThanMd ? 'center' : 'flex-start'
                                    "
                                    class="mb-2">
                                    <!-- flex-wrap="wrap" -->
                                    <TranslateNamespace path=".type1">
                                        <VFlex
                                            flex-direction="column"
                                            column-gap="2rem"
                                            class="bloc-battery lighter-bloc w-270">
                                            <div
                                                class="header-battery-type-1 p-5 subtitle-bebas is-size-5 is-uppercase is-weight-700 bg-blue-light has-text-info">
                                                <Translate path=".title"></Translate>
                                            </div>
                                            <div class="content-type p-5 is-size-6">
                                                <div class="is-weight-700 has-text-info">
                                                    <Translate
                                                        path=".usageTitle"></Translate>
                                                </div>
                                                <div class="has-text-dark">
                                                    <Translate
                                                        path=".usageContent"></Translate>
                                                </div>
                                                <hr class="divider-battery-secondary" />
                                                <div class="is-weight-700 has-text-info">
                                                    <Translate
                                                        path=".autonomyTitle"></Translate>
                                                </div>
                                                <div class="has-text-dark">
                                                    <Translate
                                                        path=".autonomyContent"></Translate>
                                                </div>
                                                <hr class="divider-battery-secondary" />
                                                <div class="is-weight-700 has-text-info">
                                                    <Translate
                                                        path=".chargerTitle"></Translate>
                                                </div>
                                                <div class="has-text-dark">
                                                    <Translate
                                                        path=".chargerContent"></Translate>
                                                </div>
                                            </div>
                                        </VFlex>
                                    </TranslateNamespace>
                                    <TranslateNamespace path=".lithiumType1">
                                        <VFlex
                                            flex-direction="column"
                                            column-gap="2rem"
                                            class="bloc-battery lighter-bloc w-270">
                                            <div
                                                class="header-battery-type-1 p-5 subtitle-bebas is-size-5 is-uppercase is-weight-700 bg-primary-light has-text-primary">
                                                <Translate path=".title"></Translate>
                                            </div>
                                            <div class="content-type p-5 is-size-6">
                                                <div
                                                    class="is-weight-700 has-text-primary">
                                                    <Translate
                                                        path=".usageTitle"></Translate>
                                                </div>
                                                <div class="has-text-dark">
                                                    <Translate
                                                        path=".usageContent"></Translate>
                                                </div>
                                                <hr class="divider-battery-primary" />
                                                <div
                                                    class="is-weight-700 has-text-primary">
                                                    <Translate
                                                        path=".autonomyTitle"></Translate>
                                                </div>
                                                <div class="has-text-dark">
                                                    <Translate
                                                        path=".autonomyContent"></Translate>
                                                </div>
                                                <hr class="divider-battery-primary" />
                                                <div
                                                    class="is-weight-700 has-text-primary">
                                                    <Translate
                                                        path=".chargerTitle"></Translate>
                                                </div>
                                                <div class="has-text-dark">
                                                    <Translate
                                                        path=".chargerContent"></Translate>
                                                </div>
                                            </div>
                                        </VFlex>
                                    </TranslateNamespace>
                                    <TranslateNamespace path=".lithiumType2">
                                        <VFlex
                                            flex-direction="column"
                                            column-gap="2rem"
                                            class="bloc-battery lighter-bloc w-270">
                                            <div
                                                class="header-battery-type-1 p-5 subtitle-bebas is-size-5 is-uppercase is-weight-700 bg-primary-light has-text-primary">
                                                <Translate path=".title"></Translate>
                                            </div>
                                            <div class="content-type p-5 is-size-6">
                                                <div
                                                    class="is-weight-700 has-text-primary">
                                                    <Translate
                                                        path=".usageTitle"></Translate>
                                                </div>
                                                <div class="has-text-dark">
                                                    <Translate
                                                        path=".usageContent"></Translate>
                                                </div>
                                                <hr class="divider-battery-primary" />
                                                <div
                                                    class="is-weight-700 has-text-primary">
                                                    <Translate
                                                        path=".autonomyTitle"></Translate>
                                                </div>
                                                <div class="has-text-dark">
                                                    <Translate
                                                        path=".autonomyContent"></Translate>
                                                </div>
                                                <hr class="divider-battery-primary" />
                                                <div
                                                    class="is-weight-700 has-text-primary">
                                                    <Translate
                                                        path=".chargerTitle"></Translate>
                                                </div>
                                                <div class="has-text-dark">
                                                    <Translate
                                                        path=".chargerContent"></Translate>
                                                </div>
                                            </div>
                                        </VFlex>
                                    </TranslateNamespace>
                                </VFlex>
                            </VFlex>
                        </TranslateNamespace>
                    </VFlex>
                </TranslateNamespace>
            </VFlex>
        </TranslateNamespace>
        <!-- END - Caracteristic -->
        <!-- Performance -->
        <TranslateNamespace path=".performance">
            <VFlex
                id="performance"
                flex-direction="column"
                class="has-background-dark py-6">
                <Title secondary>
                    <template #titleP1> <Translate path=".titleP1"></Translate></template>
                    <template #titleP2> <Translate path=".titleP2"></Translate></template>
                </Title>
                <TranslateNamespace path=".content">
                    <span
                        class="is-size-5 has-text-weight-bold has-text-primary mx-6 is-uppercase">
                        <Translate path=".content1"></Translate>
                    </span>
                    <VFlex
                        :flex-direction="smallerThanXl ? 'column' : 'row'"
                        row-gap="30px"
                        column-gap="60px"
                        class="m-6">
                        <TranslateNamespace path=".speed">
                            <BlockInfo
                                :hide-top-right-banner="true"
                                :has-white-title="true">
                                <template #content>
                                    <VFlex
                                        flex-direction="column"
                                        align-items="center"
                                        class="has-text-centered"
                                        row-gap="30px">
                                        <img
                                            :src="IconPerformanceIndicator1"
                                            alt="battery"
                                            style="height: 60px" />
                                        <div class="is-size-5 is-uppercase">
                                            <Translate path=".content"></Translate>
                                        </div>
                                        <div
                                            class="is-size-2 has-text-primary is-uppercase my-0 is-weight-700">
                                            <Translate path=".title"></Translate>
                                        </div>
                                    </VFlex>
                                </template>
                            </BlockInfo>
                        </TranslateNamespace>
                        <TranslateNamespace path=".speedLimit">
                            <BlockInfo
                                :hide-top-right-banner="true"
                                :has-white-title="true">
                                <template #content>
                                    <VFlex
                                        flex-direction="column"
                                        align-items="center"
                                        class="has-text-centered"
                                        row-gap="30px">
                                        <img
                                            :src="IconPerformanceIndicator1"
                                            alt="battery"
                                            style="height: 60px" />
                                        <div class="is-size-5 is-uppercase">
                                            <Translate path=".content"></Translate>
                                        </div>
                                        <div
                                            class="is-size-2 has-text-primary is-uppercase my-0 is-weight-700">
                                            <Translate path=".title"></Translate>
                                        </div>
                                    </VFlex>
                                </template>
                            </BlockInfo>
                        </TranslateNamespace>
                        <TranslateNamespace path=".time">
                            <BlockInfo
                                :hide-top-right-banner="true"
                                :has-white-title="true">
                                <template #content>
                                    <VFlex
                                        flex-direction="column"
                                        align-items="center"
                                        class="has-text-centered"
                                        row-gap="30px">
                                        <img
                                            :src="IconPerformanceIndicator2"
                                            alt="battery"
                                            style="height: 60px" />
                                        <div class="is-size-5 is-uppercase">
                                            <Translate path=".content"></Translate>
                                        </div>
                                        <div
                                            class="is-size-2 has-text-primary is-uppercase my-0 is-weight-700">
                                            <Translate path=".title"></Translate>
                                        </div>
                                    </VFlex>
                                </template>
                            </BlockInfo>
                        </TranslateNamespace>
                    </VFlex>
                    <VFlex
                        :flex-direction="smallerThanXl ? 'column' : 'row'"
                        justify-content="space-between"
                        column-gap="2rem"
                        row-gap="2rem"
                        class="m-6">
                        <img :src="ImagePerformance" alt="performance" class="w-350" />
                        <VFlex flex-direction="column" row-gap="1rem" column-gap="1rem">
                            <span
                                class="is-size-3 has-text-white is-weight-600 is-uppercase">
                                <Translate path=".content2"></Translate>
                            </span>
                            <span class="is-size-6 has-text-white">
                                <Translate path=".content3"></Translate>
                            </span>
                            <VFlex
                                :flex-direction="smallerThanMd ? 'column' : 'row'"
                                :align-items="smallerThanMd ? 'flex-start' : 'center'"
                                class="my-3"
                                column-gap="1rem"
                                row-gap="1rem">
                                <VFlex
                                    flex-direction="row"
                                    align-items="center"
                                    class="has-background-primary is-size-6 is-uppercase p-3 is-weight-700 has-border-radius">
                                    <img
                                        :src="IconPerformanceBattery"
                                        alt="battery"
                                        style="height: 30px"
                                        class="mr-5" />
                                    <Translate>.plumb</Translate>
                                </VFlex>
                                <VFlex
                                    flex-direction="row"
                                    align-items="center"
                                    class="has-background-secondary is-size-6 is-uppercase p-3 is-weight-700 has-border-radius">
                                    <img
                                        :src="IconPerformanceBattery"
                                        alt="battery"
                                        style="height: 30px"
                                        class="mr-5" />
                                    <Translate>.lithium</Translate>
                                </VFlex>
                            </VFlex>
                        </VFlex>
                    </VFlex>
                </TranslateNamespace>
            </VFlex>
        </TranslateNamespace>
        <!-- END - Performance -->
        <!-- Conception -->
        <TranslateNamespace path=".conception">
            <VFlex
                id="conception"
                flex-direction="column"
                class="has-background-white py-6">
                <Title>
                    <template #titleP1> <Translate path=".titleP1"></Translate></template>
                    <template #titleP2> <Translate path=".titleP2"></Translate></template>
                </Title>
                <TranslateNamespace path=".content">
                    <VFlex
                        row-gap="1rem"
                        column-gap="1rem"
                        class="px-6 mb-4 grid-conception">
                        <VFlex
                            flex-direction="column"
                            justify-content="center"
                            align-items="center"
                            column-gap="1rem"
                            row-gap="1rem"
                            class="lighter-bloc has-text-centered is-uppercase has-text-dark is-size-5 is-weight-500 p-5 w-100">
                            <img
                                :src="IconConception1"
                                alt="icone pilote débutant"
                                class="w-90" />
                            <div>
                                <Translate path=".piece1"></Translate>
                                <span class="has-text-primary">
                                    <Translate path=".piece2"></Translate
                                ></span>
                            </div>
                        </VFlex>
                        <VFlex
                            flex-direction="column"
                            justify-content="center"
                            align-items="center"
                            column-gap="1rem"
                            row-gap="1rem"
                            class="lighter-bloc has-text-centered is-uppercase has-text-dark is-size-5 is-weight-500 p-5 w-100">
                            <img
                                :src="IconConception2"
                                alt="icone pilote débutant"
                                class="w-90" />
                            <div class="mt-2">
                                <span class="has-text-primary pr-2">
                                    <Translate path=".vis1"></Translate
                                ></span>
                                <Translate path=".vis2"></Translate>
                            </div>
                        </VFlex>
                        <VFlex
                            flex-direction="column"
                            justify-content="center"
                            align-items="center"
                            column-gap="1rem"
                            row-gap="1rem"
                            class="lighter-bloc has-text-centered is-uppercase has-text-dark is-size-5 is-weight-500 p-5 w-100">
                            <img
                                :src="IconConception3"
                                alt="icone pilote débutant"
                                class="w-90" />
                            <div class="mt-2">
                                <span class="has-text-primary">
                                    <Translate path=".cable2"></Translate
                                ></span>
                                <Translate path=".cable1"></Translate>
                            </div>
                        </VFlex>
                        <VFlex
                            flex-direction="column"
                            justify-content="center"
                            align-items="center"
                            column-gap="1rem"
                            row-gap="1rem"
                            class="lighter-bloc has-text-centered is-uppercase has-text-dark is-size-5 is-weight-500 p-5 w-100">
                            <img
                                :src="IconConception4"
                                alt="icone pilote débutant"
                                class="w-90" />
                            <div class="mt-2">
                                <span class="has-text-primary pr-2">
                                    <Translate path=".duration1"></Translate
                                ></span>
                                <Translate path=".duration2"></Translate>
                            </div>
                        </VFlex>
                    </VFlex>
                    <VFlex
                        :flex-direction="smallerThanXl ? 'column' : 'row'"
                        align-items="stretch"
                        justify-content="center"
                        column-gap="1rem"
                        row-gap="1rem"
                        class="px-6">
                        <TranslateNamespace path=".innovation">
                            <VFlex
                                :flex-direction="isBetweenMdLg ? 'row' : 'column'"
                                :justify-content="isBetweenMdLg ? 'flex-start' : 'center'"
                                :align-items="isBetweenMdLg ? 'center' : 'flex-start'"
                                class="has-background-dark p-6 w-100"
                                column-gap="1rem"
                                row-gap="1rem">
                                <img
                                    :src="IconConception5"
                                    alt="icone pilote débutant"
                                    class="w-90" />
                                <div
                                    class="is-size-5 is-weight-700 has-text-white is-uppercase">
                                    <Translate path=".content1"></Translate>
                                    <span class="has-text-primary">
                                        &nbsp;<Translate path=".content2"></Translate
                                        >&nbsp;</span
                                    >
                                    <Translate path=".content3"></Translate>
                                </div>
                            </VFlex>
                        </TranslateNamespace>
                        <TranslateNamespace path=".recyclable">
                            <VFlex
                                :flex-direction="isBetweenMdLg ? 'row' : 'column'"
                                :justify-content="isBetweenMdLg ? 'flex-start' : 'center'"
                                :align-items="isBetweenMdLg ? 'center' : 'flex-start'"
                                class="has-background-dark p-6 w-100"
                                column-gap="1rem"
                                row-gap="1rem">
                                <img
                                    :src="IconConception6"
                                    alt="icone pilote débutant"
                                    class="w-90" />

                                <div
                                    class="is-size-5 is-weight-700 has-text-white is-uppercase">
                                    <Translate path=".content1"></Translate>
                                    <span class="has-text-primary">
                                        &nbsp;<Translate path=".content2"></Translate
                                        >&nbsp;</span
                                    >
                                    <Translate path=".content3"></Translate>
                                </div>
                            </VFlex>
                        </TranslateNamespace>
                        <TranslateNamespace path=".france">
                            <VFlex
                                :flex-direction="isBetweenMdLg ? 'row' : 'column'"
                                :justify-content="isBetweenMdLg ? 'flex-start' : 'center'"
                                :align-items="isBetweenMdLg ? 'center' : 'flex-start'"
                                class="has-background-dark p-6 w-100"
                                column-gap="1rem"
                                row-gap="1rem">
                                <img
                                    :src="IconIdentity3"
                                    alt="icone pilote débutant"
                                    class="w-90" />
                                <div
                                    class="is-size-5 is-weight-700 has-text-white is-uppercase">
                                    <span class="has-text-primary">
                                        <Translate path=".content2"></Translate
                                        >&nbsp;</span
                                    >
                                    <Translate path=".content3"></Translate>
                                </div>
                            </VFlex>
                        </TranslateNamespace>
                    </VFlex>
                </TranslateNamespace>
            </VFlex>
        </TranslateNamespace>
        <!-- END - Conception -->
        <!-- Securite -->
        <TranslateNamespace path=".security">
            <VFlex
                id="security"
                flex-direction="column"
                class="has-background-white py-6">
                <Title>
                    <template #titleP1> <Translate path=".titleP1"></Translate></template>
                    <template #titleP2> <Translate path=".titleP2"></Translate></template>
                </Title>
                <TranslateNamespace path=".content">
                    <span class="is-size-5 has-text-dark mx-6 mb-6">
                        <Translate path=".content1"></Translate>
                    </span>
                    <VFlex
                        flex-direction="row"
                        flex-wrap="wrap"
                        class="mx-6"
                        column-gap="30px"
                        row-gap="30px">
                        <TranslateNamespace path=".speed">
                            <VFlex
                                flex-direction="column"
                                column-gap="2rem"
                                class="bloc-battery lighter-bloc w-350 is-half">
                                <div
                                    class="header-battery-type-1 p-5 subtitle-bebas is-size-5 is-uppercase is-weight-100 bg-blue-light has-text-info">
                                    <Translate path=".title"></Translate>
                                </div>
                                <div class="content-type p-5 is-size-6">
                                    <img
                                        :src="ImageSecurity1"
                                        alt="security 1"
                                        style="height: 100px" />
                                    <div class="has-text-dark">
                                        <Translate path=".content"></Translate>
                                    </div>
                                </div>
                            </VFlex>
                        </TranslateNamespace>
                        <TranslateNamespace path=".frame">
                            <VFlex
                                flex-direction="column"
                                column-gap="2rem"
                                class="bloc-battery lighter-bloc w-350">
                                <div
                                    class="header-battery-type-1 p-5 subtitle-bebas is-size-5 is-uppercase is-weight-100 bg-blue-light has-text-info">
                                    <Translate path=".title"></Translate>
                                </div>
                                <div class="content-type p-5 is-size-6">
                                    <img
                                        :src="ImageSecurity2"
                                        alt="security 2"
                                        style="height: 100px" />
                                    <div class="has-text-dark">
                                        <Translate path=".content"></Translate>
                                    </div>
                                </div>
                            </VFlex>
                        </TranslateNamespace>
                        <TranslateNamespace path=".security">
                            <VFlex
                                flex-direction="column"
                                column-gap="2rem"
                                class="bloc-battery lighter-bloc w-350">
                                <div
                                    class="header-battery-type-1 p-5 subtitle-bebas is-size-5 is-uppercase is-weight-100 bg-blue-light has-text-info">
                                    <Translate path=".title"></Translate>
                                </div>
                                <div class="content-type p-5 is-size-6">
                                    <img
                                        :src="ImageSecurity3"
                                        alt="security 3"
                                        style="height: 100px" />
                                    <div class="has-text-dark">
                                        <Translate path=".content"></Translate>
                                    </div>
                                </div>
                            </VFlex>
                        </TranslateNamespace>
                        <TranslateNamespace path=".remote">
                            <VFlex
                                flex-direction="column"
                                column-gap="2rem"
                                class="bloc-battery lighter-bloc w-350">
                                <div
                                    class="header-battery-type-1 p-5 subtitle-bebas is-size-5 is-uppercase is-weight-100 bg-blue-light has-text-info">
                                    <Translate path=".title"></Translate>
                                </div>
                                <div class="content-type p-5 is-size-6">
                                    <img
                                        :src="ImageSecurity4"
                                        alt="security 4"
                                        style="height: 100px" />
                                    <div class="has-text-dark">
                                        <Translate path=".content"></Translate>
                                    </div>
                                </div>
                            </VFlex>
                        </TranslateNamespace>
                        <TranslateNamespace path=".pedal">
                            <VFlex
                                flex-direction="column"
                                column-gap="2rem"
                                class="bloc-battery lighter-bloc w-350">
                                <div
                                    class="header-battery-type-1 p-5 subtitle-bebas is-size-5 is-uppercase is-weight-100 bg-blue-light has-text-info">
                                    <Translate path=".title"></Translate>
                                </div>
                                <div class="content-type p-5 is-size-6">
                                    <img
                                        :src="ImageSecurity5"
                                        alt="security 5"
                                        style="height: 100px" />

                                    <div class="has-text-dark">
                                        <Translate path=".content"></Translate>
                                    </div>
                                </div>
                            </VFlex>
                        </TranslateNamespace>
                    </VFlex>
                </TranslateNamespace>
            </VFlex>
        </TranslateNamespace>
        <!-- END - Securite -->
        <!-- Durabilité -->
        <TranslateNamespace path=".sustainability">
            <VFlex
                id="sustainability"
                flex-direction="column"
                class="has-background-white py-6">
                <Title>
                    <template #titleP1> <Translate path=".titleP1"></Translate></template>
                    <template #titleP2> <Translate path=".titleP2"></Translate></template>
                </Title>
                <TranslateNamespace path=".content">
                    <span class="is-size-5 has-text-dark mx-6 mb-6">
                        <Translate path=".content1"></Translate>
                    </span>
                    <span class="is-size-3 is-weight-700 has-text-dark mx-6 is-uppercase">
                        <Translate path=".title1"></Translate>
                    </span>
                    <VFlex
                        :flex-direction="smallerThanSm ? 'column' : 'row'"
                        flex-wrap="wrap"
                        justify-content="center"
                        align-items="center"
                        row-gap="30px"
                        class="m-6">
                        <TranslateNamespace path=".form">
                            <VFlex
                                flex-direction="column"
                                align-items="center"
                                class="w-250">
                                <VFlex
                                    flex-direction="row"
                                    row-gap="1rem"
                                    column-gap="1rem"
                                    align-items="center"
                                    justify-content="center"
                                    class="lighter-bloc-round has-text-dark">
                                    <img
                                        :src="IconDurability1"
                                        alt="icone dimension"
                                        class="w-50" />
                                </VFlex>
                                <span
                                    class="is-size-6 has-text-dark is-uppercase mx-6 mt-5 mb-1">
                                    <Translate path=".content"></Translate>
                                </span>
                                <span
                                    class="is-size-4 has-text-primary is-uppercase mx-6 my-0 is-weight-700 has-text-centered">
                                    <Translate path=".content1"></Translate>
                                </span>
                            </VFlex>
                        </TranslateNamespace>
                        <TranslateNamespace path=".motor">
                            <VFlex
                                flex-direction="column"
                                align-items="center"
                                class="w-250">
                                <VFlex
                                    flex-direction="row"
                                    row-gap="1rem"
                                    column-gap="1rem"
                                    align-items="center"
                                    justify-content="center"
                                    class="lighter-bloc-round has-text-dark">
                                    <img
                                        :src="IconDurability2"
                                        alt="icone dimension"
                                        class="w-50" />
                                </VFlex>
                                <span
                                    class="is-size-6 has-text-dark is-uppercase mx-6 mt-5 mb-1">
                                    <Translate path=".content"></Translate>
                                </span>
                                <span
                                    class="is-size-4 has-text-primary is-uppercase mx-6 my-0 is-weight-700 has-text-centered">
                                    <Translate path=".content1"></Translate>
                                </span>
                            </VFlex>
                        </TranslateNamespace>
                        <TranslateNamespace path=".variator">
                            <VFlex
                                flex-direction="column"
                                align-items="center"
                                class="w-250">
                                <VFlex
                                    flex-direction="row"
                                    row-gap="1rem"
                                    column-gap="1rem"
                                    align-items="center"
                                    justify-content="center"
                                    class="lighter-bloc-round has-text-dark">
                                    <img
                                        :src="IconDurability3"
                                        alt="icone dimension"
                                        class="w-50" />
                                </VFlex>
                                <span
                                    class="is-size-6 has-text-dark is-uppercase mx-6 mt-5 mb-1">
                                    <Translate path=".content"></Translate>
                                </span>
                                <span
                                    class="is-size-4 has-text-primary is-uppercase mx-6 my-0 is-weight-700 has-text-centered">
                                    <Translate path=".content1"></Translate>
                                </span>
                            </VFlex>
                        </TranslateNamespace>
                        <TranslateNamespace path=".battery">
                            <VFlex
                                flex-direction="column"
                                align-items="center"
                                class="w-250">
                                <VFlex
                                    flex-direction="row"
                                    row-gap="1rem"
                                    column-gap="1rem"
                                    align-items="center"
                                    justify-content="center"
                                    class="lighter-bloc-round has-text-dark">
                                    <img
                                        :src="IconDurability4"
                                        alt="icone dimension"
                                        class="w-50" />
                                </VFlex>
                                <span
                                    class="is-size-6 has-text-dark is-uppercase mx-6 mt-5 mb-1">
                                    <Translate path=".content"></Translate>
                                </span>
                                <span
                                    class="is-size-4 has-text-primary is-uppercase mx-6 my-0 is-weight-700 has-text-centered">
                                    <Translate path=".content1"></Translate>
                                </span>
                            </VFlex>
                        </TranslateNamespace>
                        <TranslateNamespace path=".charger">
                            <VFlex
                                flex-direction="column"
                                align-items="center"
                                class="w-250">
                                <VFlex
                                    flex-direction="row"
                                    row-gap="1rem"
                                    column-gap="1rem"
                                    align-items="center"
                                    justify-content="center"
                                    class="lighter-bloc-round has-text-dark">
                                    <img
                                        :src="IconDurability5"
                                        alt="icone dimension"
                                        class="w-50" />
                                </VFlex>
                                <span
                                    class="is-size-6 has-text-dark is-uppercase mx-6 mt-5 mb-1">
                                    <Translate path=".content"></Translate>
                                </span>
                                <span
                                    class="is-size-4 has-text-primary is-uppercase mx-6 my-0 is-weight-700 has-text-centered">
                                    <Translate path=".content1"></Translate>
                                </span>
                            </VFlex>
                        </TranslateNamespace>
                    </VFlex>
                    <VFlex
                        :flex-direction="smallerThanXl ? 'column' : 'row'"
                        column-gap="30px"
                        row-gap="30px"
                        class="mx-6">
                        <TranslateNamespace path=".budget">
                            <VFlex
                                flex-direction="column"
                                column-gap="2rem"
                                class="bloc-battery lighter-bloc is-flex">
                                <div
                                    class="header-battery-type-1 p-5 subtitle-bebas is-size-5 is-uppercase is-weight-600 bg-blue-light has-text-info">
                                    <Translate path=".title"></Translate>
                                </div>
                                <div class="content-type p-5 is-size-6 has-text-info">
                                    <Translate path=".content"></Translate>
                                </div>
                            </VFlex>
                        </TranslateNamespace>
                        <TranslateNamespace path=".maintenance">
                            <VFlex
                                flex-direction="column"
                                column-gap="2rem"
                                class="bloc-battery lighter-bloc is-flex">
                                <div
                                    class="header-battery-type-1 p-5 subtitle-bebas is-size-5 is-uppercase is-weight-600 bg-blue-light has-text-info">
                                    <Translate path=".title"></Translate>
                                </div>
                                <div class="content-type p-5 is-size-6 has-text-info">
                                    <Translate path=".content"></Translate>
                                </div>
                            </VFlex>
                        </TranslateNamespace>
                    </VFlex>
                </TranslateNamespace>
            </VFlex>
        </TranslateNamespace>
        <!-- END - Durabilité -->
        <!-- Rentabilité -->
        <TranslateNamespace path=".profitability">
            <VFlex
                id="profitability"
                flex-direction="column"
                class="has-background-dark py-6">
                <Title secondary>
                    <template #titleP1> <Translate path=".titleP1"></Translate></template>
                    <template #titleP2> <Translate path=".titleP2"></Translate></template>
                </Title>
                <TranslateNamespace path=".content">
                    <span class="is-size-5 has-text-white mx-6">
                        <Translate path=".content1"></Translate>
                    </span>
                    <VFlex
                        :flex-direction="smallerThanXl ? 'column' : 'row'"
                        row-gap="30px"
                        column-gap="30px"
                        class="m-6">
                        <TranslateNamespace path=".short">
                            <BlockInfo
                                :hide-top-right-banner="true"
                                :has-white-title="true">
                                <template #title>
                                    <Translate path=".title"></Translate>
                                </template>

                                <template #content>
                                    <div class="is-size-6">
                                        <Translate path=".content"></Translate>
                                    </div>
                                </template>
                            </BlockInfo>
                        </TranslateNamespace>
                        <TranslateNamespace path=".middle">
                            <BlockInfo
                                :hide-top-right-banner="true"
                                :has-white-title="true">
                                <template #title>
                                    <Translate path=".title"></Translate>
                                </template>

                                <template #content>
                                    <div class="is-size-6">
                                        <Translate path=".content"></Translate>
                                    </div>
                                </template>
                            </BlockInfo>
                        </TranslateNamespace>
                        <TranslateNamespace path=".long">
                            <BlockInfo
                                :hide-top-right-banner="true"
                                :has-white-title="true">
                                <template #title>
                                    <Translate path=".title"></Translate>
                                </template>

                                <template #content>
                                    <div class="is-size-6">
                                        <Translate path=".content"></Translate>
                                    </div>
                                </template>
                            </BlockInfo>
                        </TranslateNamespace>
                    </VFlex>
                </TranslateNamespace>
            </VFlex>
        </TranslateNamespace>
        <!-- END - Rentabilité -->
        <Footer></Footer>
    </VFlex>
</template>

<style lang="scss">
@use "sass:color";

.subtitle-bebas {
    font-family: "Bebas Neue";
    line-height: 1.1;
}

.w-100 {
    width: 100%;
}

.w-200 {
    width: 200px;
}

.w-350 {
    width: 350px;
}

.w-250 {
    width: 250px !important;
}

.w-50 {
    width: 50px;
}

.img-identity-karting {
    border-radius: 5px;
    background-image: v-bind("`url('${ImageIdentity}')`");
    background-size: cover;
    background-position: center;
    width: 100%;
    min-height: 300px;
}

.bloc-icon-identity {
    line-height: 1.4;

    .icon-identity {
        height: 70px;
    }

    .subtitle-icon {
        letter-spacing: 0.3rem;
        max-width: 250px;
    }
}

.lighter-bloc {
    background-color: $grey-lighter;
    border-radius: 5px;
}

.lighter-bloc-round {
    background-color: $grey-lighter;
    border-radius: 100px;
    height: 160px;
    width: 160px;
}

.w-35 {
    width: 35px;
}

.h-90 {
    height: 90px;
}

.w-90 {
    width: 90px;
}

.typology {
    width: 150px;
    border-radius: 5px;
}

.pilot-type {
    width: 190px;
    border-radius: 5px;
}

.grid-conception {
    display: grid !important;
    grid-template-columns: repeat(4, 1fr);
}

@media (max-width: 1200px) {
    .grid-conception {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 767px) {
    .grid-conception {
        grid-template-columns: repeat(1, 1fr);
    }

    .typology {
        width: 90px;
        font-size: 1rem !important;
    }

    .w-90 {
        width: 80px;
    }

    .h-90 {
        height: 70px;
    }

    .pilot-type {
        width: 140px;
        font-size: 1rem !important;
    }
}

@media (max-width: 1280px) {
    .w-270 {
        max-width: 100%;
    }

    .w-350 {
        width: 100%;
    }
}

.bloc-battery {
    border-radius: 5px;
}

.divider-battery-primary {
    background-color: $primary;
    height: 1px;
}

.divider-battery-secondary {
    background-color: $info;
    height: 1px;
}

.bg-blue-light {
    background-color: $info-lighter;
    border-radius: 5px 5px 0 0;
}

.bg-primary-light {
    background-color: $primary-lighter;
    border-radius: 5px 5px 0 0;
}

.image-header {
    .image-header-background {
        display: none;
    }
}

.video-landing {
    width: 100%;
    min-height: 100vh;
    object-fit: cover;
    pointer-events: none;
}

.image-header-image {
    align-content: center;

    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
}
</style>
